import Vue from 'vue';
import ContactListCellRendererTags
from '@/views/modules/contacts/cell-renderers/ContactListCellRendererTags.vue';
import { mapActions } from 'vuex';

/**
 * Tags floating filter
 *
 * @module views/modules/contacts/contact/filters/TagsFloatingFilter
 * @author Dilan Useche <dilan8810@gmail.com>
 *
 * @vue-data {Array.<Object>} tags - tags to use on filter
 * @vue-event {void} remove - remove one tag from tags to filter
 * @vue-event {void} onParentModelChanged - called on changed tags parent model
 */
export default Vue.extend({
  name: 'TagsFloatingFilter',
  template: `
    <contact-list-cell-renderer-tags
      :items="tagsMapped"
      :show-maximum="2"
      show-clear
      @clear="remove"
      />
    `,
  components: {
    ContactListCellRendererTags,
  },
  data() {
    return {
      tags: [],
      tagsMapped: [],
    };
  },
  methods: {
    ...mapActions({
      fetchAllTags: 'tag/fetchAllTags',
    }),
    remove() {
      this.tags = [];
      this.tagsMapped = [];
      this.params.parentFilterInstance((instance) => {
        instance.setModel(null);
      });
    },
    async onParentModelChanged(parentModel) {
      if (parentModel && parentModel.filter && Array.isArray(parentModel.filter)) {
        this.tags = parentModel.filter;
        this.tagsMapped = this.tags;

        if (this.tags.some((tag) => typeof tag !== 'object')) {
          const response = await this.fetchAllTags({
            filters: {
              _id: {
                filterType: this.$enums.AppFilterType.ENUM,
                type: this.$enums.AppFilter.FilterType.Enum.Type.ONE,
                filter: this.tags.map((tag) => (typeof tag === 'object' ? tag.id : tag)),
              },
            },
          });
          this.tagsMapped = response.data;
        }
      } else {
        this.tags = [];
        this.tagsMapped = [];
      }
    },
  },
});
